import axios from 'axios'

const state = {
  popup: false,
  templates: [],
  template: {
    _id: '',
    title: '',
    content: '',
    number: 1
  }
}

const getters = {
  popup: state => state.popup,
  templates: state => state.templates,
  template: state => state.template
}

const mutations = {
  popup: (state, status) => state.popup = status,
  addTemplate: (state, template) => state.templates.push(template),
  templates: (state, templates) => state.templates = templates,
  template: (state, template) => state.template = template,
  editTemplate: (state, template) => {
    let index = state.templates.findIndex(t => t._id.toString() === template._id.toString())
    if (index >= 0) {
      for (let [key, value] of Object.entries(template)) {
        state.templates[index][key] = value
      }
    }
  }
}

const actions = {
  LOAD_TEMPLATES: async ctx => {
    try {
      const { data: templates } = await axios.get('/templates')
      if (templates.length) ctx.commit('templates', templates)
    } catch (err) {
      console.error(err)
    }
  },
  ADD_TEMPLATE: async (ctx, data) => {
    try {
      const { data: template } = await axios.post('/templates', data)
      if (template) ctx.commit('addTemplate', template)
    } catch (err) {
      console.error(err)
    }
  },
  EDIT_TEMPLATE: async ctx => {
    try {
      const { data: template } = await axios.patch('/templates', { ...ctx.state.template })
      if (template) ctx.commit('editTemplate', template)
    } catch (err) {
      console.error(err)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}